var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"home",staticStyle:{"text-align":"center"}},[_c('router-link',{staticClass:"btn btn-black login-btn mt-5 w-100",attrs:{"to":"/login"}},[_vm._v("Login")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }